import { lazy } from "react";
import { Route } from "react-router-dom";

const Appointments = lazy(() => import("pages/Appointments"));
const List = lazy(() => import("pages/Appointments/AppointmentsList"));
const Details = lazy(() => import("pages/Appointments/AppointmentDetails"));

const AppointmentsRoutes = (
  <Route path="appointments" element={<Appointments />}>
    <Route index element={<List />} />
    <Route path=":id" element={<Details />} />
  </Route>
);

export default AppointmentsRoutes;
